import React from 'react';
import { NeonButton } from './ui/NeonButton';
export function FooterCTA() {
  return <footer className="py-24 bg-[#0A0A0A] border-t border-white/5 text-center relative overflow-hidden" data-id="element-88">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#FF6B35] blur-[150px] opacity-10 pointer-events-none" data-id="element-89" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-90">
        <h2 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter uppercase italic" data-id="element-91">
          Enfocate. <br data-id="element-92" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FF9E7D]" data-id="element-93">
            Ejecutá.
          </span>
        </h2>

        <div className="flex flex-col items-center gap-6" data-id="element-94">
          <div className="flex items-baseline gap-3" data-id="element-95">
            <span className="text-2xl text-gray-600 line-through" data-id="element-96">$85.93</span>
            <span className="text-5xl font-bold text-white" data-id="element-97">$17.99</span>
          </div>

          <p className="text-xs text-gray-500 -mt-2" data-id="element-98">
            * Precio en USD. Se mostrará en tu moneda local al hacer clic
          </p>

          <a href="https://sistemaenfocado.com/cart/43851175264365:1" target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-block',
          textAlign: 'center',
          padding: '20px 32px',
          borderRadius: '14px',
          background: '#FF6A2A',
          color: '#111',
          fontWeight: 800,
          letterSpacing: '.06em',
          textDecoration: 'none',
          fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,Arial',
          fontSize: '18px',
          minWidth: '250px'
        }} data-id="element-99">
            OBTENER ACCESO INSTANTÁNEO
          </a>

          <p className="text-gray-500 text-sm mt-8" data-id="element-100">
            © {new Date().getFullYear()} Enfocado. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}